const KB_BASE = "https://ikizmet.zendesk.com/hc/en-us/articles/";

export const ILEARN_URLS = {
  dashboard: {
    attendance: `${KB_BASE}13202067443981-Attendance`,
    totalRevenue: `${KB_BASE}19328809438221-Total-Revenue`,
    membershipUnits: `${KB_BASE}22468972437261-Membership-Units`,
    firstTimeClients: `${KB_BASE}19680918007181-First-Time-Clients`,
    marketing: `${KB_BASE}22572012464781-Marketing`,
    membershipRevenue: `${KB_BASE}21197761657229-Membership-Revenue`,
    leadsAdded: `${KB_BASE}19318413301261-Leads-Added`
  },
  marketing: {
    introRevenue: `${KB_BASE}44180160816141-Intro-Revenue`,
    numOfIntros: `${KB_BASE}44180843167373-Number-of-Intros-Sold`,
    referrals: `${KB_BASE}23365995867149-Referrals`,
    totalRevenue: `${KB_BASE}23659487963021-Total-Revenue-by-Referral`
  },
  retention: {
    customerRetentionHeatmap: `${KB_BASE}21944025421965-Customer-Retention-Heatmap`,
    introConversion: `${KB_BASE}44205277682445-New-Client-Retention`,
    introBreakdown: `${KB_BASE}44205097013133-Intro-Breakdown`,
    noVisitAfterFirstVisit: `${KB_BASE}19328402200845-No-Visit-After-First-Visit`
  },
  multiLocationUniversal: {
    universal: `${KB_BASE}13202517905933-Multi-Location`
  },
  multiLocationOverview: {
    overview: `${KB_BASE}21554157215373-Multi-Location-Overview`
  },
  brandLeaderBoard: {
    brandLeaderboard: `${KB_BASE}25930121351693-Brand-Leaderboard`
  },
  userLogins: {
    loginReport: `${KB_BASE}35305449778445-Login-Report-Page`
  },
  clientProfile: {
    clientProfiles: `${KB_BASE}19322755471629-Client-Profile-Views`
  },
  instructorPerformance: {
    instructorUtilization: `${KB_BASE}32595118043917-Instructor-Utilization`,
    instructorClosing: `${KB_BASE}32603114417549-Instructor-Closing`,
    firstVisitConversions: `${KB_BASE}29407629714829-First-Visit-Conversions`
  },
  salesActivity: {
    laser: `${KB_BASE}21934040129677-LASER`,
    leadStatus: `${KB_BASE}43600032134797-Lead-Status`,
    leadActivity: `${KB_BASE}40022453242125-Lead-Activity`
  },
  salesRevenue: {
    totalRevenue: `${KB_BASE}44235941748493-Total-Revenue`,
    serviceSales: `${KB_BASE}13201934202637-Service-Sales`,
    productSales: `${KB_BASE}13201880031117-Product-Sales`,
    pastDuePerformance: `${KB_BASE}37272905811469-Past-Due-Performance`
  },
  agreements: {
    agreementsAnalysis: `${KB_BASE}40420743333773-Agreements-Analysis`
  },
  demographics: {
    demographics: `${KB_BASE}21753625425805-Demographics-Module`
  },
  ltvAndLength: {
    membershipLength: `${KB_BASE}25929927994253-Membership-Length`,
    lifetimeValue: `${KB_BASE}26302385585037-Lifetime-Value-by-Membership-Type`
  },
  goals: {
    goalsByStore: `${KB_BASE}33929434795661-Goals-by-Store`,
    goalsByStaff: `${KB_BASE}40218659249165-Goals-by-Staff`
  },
  dailyPulse: {
    dailyPulse: `${KB_BASE}19318984142093-Daily-Pulse`
  },
  staffActivity: {
    staffSalesAndConversions: `${KB_BASE}19116715948173-Staff-Activity-Sales-Conversions`,
    activities: `${KB_BASE}14740116004109-Staff-Activity`
  },
  packages: {
    packagesSales: `${KB_BASE}44237483381133-Packages-Sales`
  },
  checkIns: {
    checkIns: `${KB_BASE}44212624939917-Check-Ins`
  },
  sessions: {
    remainingSessions: `${KB_BASE}30390907676045-Remaining-Sessions`
  },
  services: {
    serviceBookings: `${KB_BASE}40425522306445-Service-Booking`
  },
  classUtilization: {
    classUtilization: `${KB_BASE}23340402787981-Class-Utilization`
  },
  attendance: {
    activeClients: `${KB_BASE}13202183181069-Active-Clients`,
    totalVisits: `${KB_BASE}28838199644813-Total-Visits`,
    averageNumberOfVisits: `${KB_BASE}28883407836557-Average-Number-of-Visits`,
    bookings: `${KB_BASE}44211588424717-Bookings`,
    classCount: `${KB_BASE}42499003603341-Class-Count`
  },
  membership: {
    membersByStatus: `${KB_BASE}22579892265485-Members-by-Status`,
    membersByClubReadyProfile: `${KB_BASE}22866641941261-Members-by-ClubReady-Profile`,
    membersByPaying: `${KB_BASE}22867421581581-Members-by-Paying`,
    membersByPayingExcludingZeroSales: `${KB_BASE}22890040093325-Members-by-Paying-Excluding-Zero-Sales`,
    membersByMembershipType: `${KB_BASE}29006074697997-Members-by-Membership-Type`,
    membershipBreakdown: `${KB_BASE}21755494223245-Membership-Breakdown`,
    atRiskMembers: `${KB_BASE}22473938673165-At-Risk-Members`,
    attritionAndCancelReasons: `${KB_BASE}32074514571789-Attrition-Cancel-Reasons`,
    zeroVisitMembers: `${KB_BASE}14355114415629-Zero-Visit-Members`,
    membershipRetentionHeatmap: `${KB_BASE}43588813697549-Membership-Retention-Heatmap`,
    memberVisits: `${KB_BASE}43616290860685-Member-Visits`,
    bookings: `${KB_BASE}44211588424717-Bookings`,
    classCount: `${KB_BASE}42499003603341-Class-Count`
  }
};
